function onlyNumbers(value) {
  if (value)
    return value.replace(/\D/g, '')

  return ''
}

export function MaskCpfCnpj(value) {
  const numbers = onlyNumbers(value);

  if (numbers.length <= 11) {
    return cpf(numbers);
  } else {
    return cnpj(numbers);
  }
}

function cpf(value) {
  if (value)
    return value
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
}

function cnpj(value) {
  if (value)
    return value
      .replace(/(\d{2})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1/$2')
      .replace(/(\d{4})(\d{1,2})$/, '$1-$2');
}